import React from "react";
import { AiFillHome } from "react-icons/ai";
import {
  FaAngleRight,
  FaFacebookSquare,
  FaInstagram,
  FaShippingFast,
} from "react-icons/fa";
import { BsFillPrinterFill } from "react-icons/bs";
import { GiLeatherArmor } from "react-icons/gi";
import { LuThumbsUp } from "react-icons/lu";
import { homefilterApi } from "../../Services/Operations/ProductAPI";
import { Link, useNavigate } from "react-router-dom";
import { FaFacebook } from "react-icons/fa";

function Footer() {
  const navigate = useNavigate();

  const handleSportClick = async (categoryName) => {
    try {
      console.log("categoryName : ", categoryName);
      const products = await homefilterApi(categoryName);
      console.log("Products for:", categoryName, products);

      navigate("/AllListingPage", {
        state: {
          products: products.data,
        },
      });
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  return (
    <>

      <footer
        style={{ backgroundColor: "#000", color: "#fff", padding: "2rem 10px" }}
      >
        <div style={{ }}>
          <div className="footer-grid">
            <div>
              <div style={{ marginBottom: "1rem" }}>
                <img
                  src="/asset/LogoWhite.png"
                  alt="Sports"
                  style={{ width:"90%" }}
                />
              </div>
            </div>

            <div>
              <h3 style={headingStyle}>Types of sport</h3>
              <ul style={listStyle}>
                {[
                  "Running",
                  "Fitness",
                  "Football",
                  "Badminton",
                  "Cycling",
                  "Cricket",
                ].map((sport) => (
                  <li key={sport} style={listItemStyle} className="listItemStyle">
                    <a
                      style={linkStyle}
                      onClick={() => handleSportClick(sport.toLowerCase())}
                    >
                      {sport}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 style={headingStyle}>Shield Sports</h3>
              <ul style={listStyle}>
                <li style={listItemStyle} className="listItemStyle">
                  <a href="/about" style={linkStyle}>
                    About Us
                  </a>
                </li>
                <li style={listItemStyle} className="listItemStyle">
                  <a href="/blog" style={linkStyle}>
                    Blogs
                  </a>
                </li>
                <li style={listItemStyle} className="listItemStyle">
                  <a style={linkStyle}>FAQ</a>
                </li>
              </ul>
            </div>

            <div>
              <h3 style={headingStyle}>Information</h3>
              <ul style={listStyle}>
                <li style={listItemStyle} className="listItemStyle">
                  <a style={linkStyle}>Privacy Policy</a>
                </li>
                <li style={listItemStyle} className="listItemStyle">
                  <a style={linkStyle}>Term Of Condition</a>
                </li>
                <li style={listItemStyle} className="listItemStyle">
                  <a style={linkStyle}>Return Policy</a>
                </li>
              </ul>
            </div>

            <div>
              <h3 style={headingStyle}>Purchase order</h3>
              <ul style={listStyle}>
                <li style={listItemStyle} className="listItemStyle">
                  <a style={linkStyle}>Create my design</a>
                </li>
                <li style={listItemStyle} className="listItemStyle">
                  <a style={linkStyle}>Order & delivery</a>
                </li>
                <li style={listItemStyle} className="listItemStyle">
                  <a style={linkStyle}>3D Configurator</a>
                </li>
                <li style={listItemStyle} className="listItemStyle">
                  <a style={linkStyle}>Order help</a>
                </li>
              </ul>
            </div>

            <div>
              <h3 style={headingStyle}>Social Media</h3>
              <ul style={listStyle}>
                <li
                  style={{
                    ...listItemStyle,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span style={{ marginRight: "10px" }}><FaFacebook /></span>
                  <a className="listItemStyle" style={linkStyle}>Facebook</a>
                </li>
                <li
                  style={{
                    ...listItemStyle,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span style={{ marginRight: "10px" }}><FaInstagram /></span>
                  <a className="listItemStyle" style={linkStyle}>Instagram</a>
                </li>
              </ul>
            </div>
          </div>

          <div
            style={{
              borderTop: "1px solid #333",
              paddingTop: "1rem",
              textAlign: "center",
            }}
          >
            <p style={{ margin: 0 ,fontSize: "15px"}}>© 2025 Shield Sports</p>
          </div>
        </div>
      </footer>

      <style>{`
        .footer-grid {
          display: grid;
             grid-template-columns: repeat(auto-fit, minmax(178px, 1fr));
    gap: 9px;
    margin-bottom: 1rem
16px
;

        }

         .listItemStyle {

  font-size: 15px,
};

        @media (max-width: 767px) {
          .footer-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 1rem;
          }

          footer {
            padding: 1rem 0 !important;
          }

          footer h3 {
            font-size: 1rem !important;
            margin-bottom: 0.5rem !important;
          }

          footer li {
            margin-bottom: 0.3rem !important;
            font-size: 0.9rem;
          }

          footer img {
            height: 40px !important;
          }
            .listItemStyle {

  font-size: 13px,
};
        }

        @media (max-width: 400px) {
          .footer-grid {
            grid-template-columns: 1fr;
          }

          footer h3 {
            margin-top: 1rem !important;
          }
        }
      `}</style>
    </>
  );
}

// Style variables

const headingStyle = {
  fontSize: "1.2rem",
  marginBottom: "1rem",
  fontWeight: "600",
};

const listStyle = {
  listStyle: "none",
  padding: 0,
  margin: 0,
};

const listItemStyle = {
  marginBottom: "0.5rem",
};

const linkStyle = {
  color: "#fff",
  textDecoration: "none",
  cursor: "pointer",
};

export default Footer;
